export default __webpack_public_path__ + "static/media/21_SchererGruppe-DTM-Documentary-EschweilerPhotography_21A5330.1d5c602e.jpg";